module.exports = __webpack_public_path__ + "static/media/599.702(8).39e1b802.pdf";